import React, { useEffect, useState } from 'react';

function SeasonSelector({ seasonId, setSeasonId, admin }) {
  const [seasons, setSeasons] = useState([]);
  const [newSeason, setNewSeason] = useState("");

  useEffect(() => {
    fetch('/api/seasons')
      .then(res => res.json())
      .then(data => {
        setSeasons(data);
        if (data.length && !seasonId) {
          // Najdi výchozí sezónu podle aktuálního data
          const today = new Date();
          let found = null;
          // Hledáme první sezónu, jejíž název obsahuje aktuální nebo budoucí rok
          for (let s of data) {
            // Očekává se formát např. "2024/2025" nebo "2025"
            const match = s.name.match(/(\d{4})/g);
            if (match) {
              // Pokud je rozsah let, vezmi první rok
              const year = parseInt(match[0], 10);
              if (year === today.getFullYear() || year === today.getFullYear() + 1) {
                found = s;
                break;
              }
              if (year > today.getFullYear()) {
                // Pokud je sezóna v budoucnu, ignoruj
                continue;
              }
              // Pokud je aktuální rok větší nebo rovno roku sezóny, zapamatuj si ji jako možnou
              if (!found || year > parseInt(found.name, 10)) {
                found = s;
              }
            }
          }
          if (!found) found = data[0]; // fallback na nejnovější
          setSeasonId(found.id);
        }
      });
  }, [seasonId, setSeasonId]);

  const handleDeleteSeason = () => {
    if (!seasonId) return;
    const current = seasons.find(s => s.id === seasonId);
    if (!window.confirm(`Opravdu smazat sezónu "${current ? current.name : ''}"? Smazat lze pouze prázdnou sezónu (bez týmů a zápasů).`)) return;
    fetch(`/api/seasons/${seasonId}`, { method: 'DELETE' })
      .then(async res => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          alert(data.error || 'Sezónu se nepodařilo smazat.');
          return;
        }
        fetch('/api/seasons')
          .then(r => r.json())
          .then(list => {
            setSeasons(list);
            setSeasonId(list.length ? list[0].id : null);
          });
      })
      .catch(() => alert('Chyba při mazání sezóny.'));
  };

  const handleAddSeason = e => {
    e.preventDefault();
    if (!newSeason.trim()) return;
    fetch('/api/seasons', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: newSeason })
    })
      .then(res => res.json())
      .then(s => {
        // Po přidání nové sezóny načti znovu seznam sezón a nastav novou jako aktivní
        fetch('/api/seasons')
          .then(res => res.json())
          .then(data => {
            setSeasons(data);
            setSeasonId(s.id);
            setNewSeason("");
          });
      });
  };


  return (
    <div className="card mb-3 p-3">
      <div className="row g-2 align-items-end">
        <div className="col-12 col-md-auto">
          <label className="form-label mb-1">Sezóna:</label>
          <select
            className="form-select"
            value={seasonId || ''}
            onChange={e => setSeasonId(Number(e.target.value))}
          >
            <option value='' disabled>Vyberte sezónu</option>
            {seasons.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
        {admin && (
          <div className="col-12 col-md-auto mt-2 mt-md-0">
            <form className="d-flex gap-2" onSubmit={handleAddSeason}>
              <input
                type="text"
                className="form-control"
                value={newSeason}
                onChange={e => setNewSeason(e.target.value)}
                placeholder="Nová sezóna"
              />
              <button type="submit" className="btn btn-success">Přidat</button>
            </form>
          </div>
        )}
        {admin && seasonId && (
          <div className="col-12 col-md-auto mt-2 mt-md-0">
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={handleDeleteSeason}
              title="Smazat lze pouze prázdnou sezónu (bez týmů a zápasů)"
            >
              Smazat sezónu
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SeasonSelector;
